export default __webpack_public_path__ + "assets/saintvincentandthegrenadines-flag.png";